import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../Components/Header'; // Adjusted the path
import '../App.css';

const Login = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();

    if (email && password) {
      console.log('Logging in with:', { email, password });

      // Simulate login and store user
      localStorage.setItem('user', JSON.stringify({ email }));

      // Redirect to dashboard
      navigate('/dashboard');
    }
  };

  return (
    <div className="login-page">
      <Header /> {/* Use the Header component here */}

      <section className="login-section">
        <div className="container">
          <h2>Login to Your Account</h2>
          <form onSubmit={handleSubmit}>
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />

            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />

            <button type="submit" className="btn-primary">Log In</button>
          </form>

          <p>Don't have an account? <a href="/signup">Sign Up</a></p>
        </div>
      </section>

      <footer>
        <div className="footer-content">
          <p>© {new Date().getFullYear()} Chaman Hospital, Bahadurgarh, Patiala. All Rights Reserved.</p>
        </div>
      </footer>
    </div>
  );
};

export default Login;
